import { render, staticRenderFns } from "./WpAdminSsoModal.vue?vue&type=template&id=12808af0&scoped=true"
import script from "./WpAdminSsoModal.vue?vue&type=script&lang=js"
export * from "./WpAdminSsoModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.scss?vue&type=style&index=0&id=12808af0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12808af0",
  null
  
)

export default component.exports